export enum ErrorEnum {
  INN_EXISTS = 'error.inn.exists',
  PRIMARY_ID_EXISTS = 'error.primaryId.exists',
  VERIFICATION_TOKEN_NOT_VALID = 'error.verificationToken.notValid',
  VERIFICATION_CODE_NOT_VALID = 'error.validationCode',
  SMS_SEND_ERROR = 'error.sms.send',
  SMS_ATTEMPT_COUNT_ERROR = 'error.sms.attempt',
  ACCOUNT_ALREADY_EXISTS = 'error.account.alreadyExists',
  UBKI_IDENT_PHOTO_NOT_CORRECT = 'error.ubki-ident.photo-not-correct',
  UBKI_SELFIE_NO_VALID_IDENTITIES = 'ubki-selfie.no-valid-identities',
}
